module.exports = __webpack_public_path__ + "img/扫脸.65f2a6c2.png";